import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Surveyed() {
  return (
    <div className="portfolio-surveyed">
      <div className="portfolio-description">
        <p>
          A React component and published{" "}
          <a
            href="https://www.npmjs.com/package/surveyed"
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "#c700f0eb" }}
          >
            npm package
          </a>
          .
        </p>
        <p>
          It was first built for taking surveys in{" "}
          <a
            href="https://www.linkedin.com/company/gigzoapp/"
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "#c700f0eb" }}
          >
            7Confirmations
          </a>
          , but then came out to be an opensource project.
        </p>
        <p>
          Currently in development phase, and{" "}
          <a
            href="https://github.com/farthour/surveyed-app"
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "#c700f0eb" }}
          >
            input data creation form
          </a>{" "}
          is about to launch.
        </p>
      </div>
      <div className="row">
        <div>
          <LazyLoadImage
            src="images/portfolio/surveyed/surveyed-demo.gif"
            alt="Surveyed component preview"
            style={{ width: "100%" }}
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
}

export default Surveyed;
